export default __webpack_public_path__ + "static/media/0.b38e276f.svg";